import { Chart } from 'chart.js';
import { getVoteColor } from '../theme';
import { customTooltipCallback } from '../tooltip';
import { VotingChartSettings } from './types';

export function setupVotingChart(
  chartContext: HTMLCanvasElement,
  settings: VotingChartSettings
) {
  const data = generateData(settings);

  new Chart(chartContext, {
    type: 'scatter',
    data: {
      datasets: [
        {
          data: data.map((point) => ({ x: point.x, y: point.y })),
          backgroundColor: data.map((x) => x.color),
          pointRadius: 7,
          pointBorderWidth: 0,
          pointHoverRadius: 7,
          pointHoverBorderWidth: 0,
        },
      ],
    },
    options: {
      aspectRatio: 1,
      layout: {
        padding: {
          left: 20,
        },
      },
      scales: {
        x: {
          max: 9.3,
          display: false,
          grid: {
            display: false,
          },
        },
        y: {
          display: false,
          grid: {
            display: false,
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        tooltip: {
          enabled: false,
          external: (context) =>
            customTooltipCallback(
              context,
              (tooltip) => data[tooltip.dataIndex].label
            ),
        },
      },
    },
  });
}

interface VotingDataPoint {
  x: number;
  y: number;
  color: string;
  label: string;
}

function generateData(settings: VotingChartSettings) {
  const data: VotingDataPoint[] = [];
  const points: Array<{ color: string; label: string }> = [];

  for (const dataPoint of settings.dataSet.data) {
    for (let i = 0; i < dataPoint.count; i++) {
      points.push({
        color: getVoteColor(dataPoint.voteType),
        label: dataPoint.label,
      });
    }
  }

  for (let row = 0; row > -15; row--) {
    for (let col = 0; col < 10; col++) {
      const index = -1 * (row * 10 - col);

      data.push({
        x: col,
        y: row,
        color: points[index]?.color,
        label: points[index]?.label,
      });
    }
  }

  return data;
}
